import { makeStyles } from "@material-ui/core";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import { format } from "date-fns";
import React from "react";

export default function INRWalletCard(props) {
  const classes = useStyles();

  const statusDict = {
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };
  const titleCase = (str) => {
    return str.replace(/\w\S*/g, (t) => {
      return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
    });
  };
  function getSideText(side) {
    switch (side) {
      case "BUY":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Buy</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "SELL":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Sell</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "WITHDRAW":
        return (
          <div>
            <span className="text-pb-secondary-100 font-bold">Withdraw</span>
          </div>
        );
      case "DEPOSIT":
        return (
          <div>
            <span className="text-pb-primary-100 font-bold">Deposit</span>
          </div>
        );
    }
  }
  return (
    <div className="py-3">
      <div className="flex justify-between">
        <div>
          <div className=" mb-3 flex items-center">
            <div className="mr-3">
              <div
                className={`${
                  classes.circle
                } dark:text-[#141828] text-gray-200 flex items-center justify-center ${
                  props.transaction.side == "DEPOSIT"
                    ? "bg-[#1F9358]"
                    : "bg-[#E04D5C]"
                }`}
              >
                {props.transaction.side == "DEPOSIT" ? (
                  <ArrowDownward></ArrowDownward>
                ) : (
                  <ArrowUpward></ArrowUpward>
                )}
              </div>
            </div>
            <div>
              {/* <Icon className="mr-2" icon={props.transaction.coin.toLowerCase()} size={26} /> */}
              <div>
                <h3>₹{props.transaction.amount}</h3>
              </div>
              <div className="text-gray-800 dark:text-gray-400 text-xs">
                <p className="mb-1">
                  {format(
                    new Date(props.transaction.createdAt),
                    "dd.MM.yy, hh:mm:ss aaaaa'm'"
                  )}
                </p>
                <p>{titleCase(props.transaction.side)}</p>
              </div>
              <p className="">{props.transaction.coin}</p>{" "}
            </div>
          </div>
          {props.transaction.quantity && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Quantity
              </span>{" "}
              <span>{props.transaction.quantity}</span>
            </span>
          )}
          {props.transaction.price && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Price
              </span>{" "}
              <span>₹{props.transaction.price}</span>
            </span>
          )}
          {Boolean(props.transaction.totalAmount) && (
            <span className="flex items-center">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Total
              </span>{" "}
              <span>₹{props.transaction.totalAmount}</span>
            </span>
          )}
        </div>
        <div className="flex flex-col justify-between text-right">
          <div className="">
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              Balance:
            </span>{" "}
            ₹{Number(props.transaction.userPostBalance).toFixed(2)}{" "}
          </div>
          <div>
            <div
              className={`font-bold mb-2 normal-case ${
                (
                  statusDict[props.transaction.status] ||
                  props.transaction.status
                )
                  .toLowerCase()
                  .includes("success")
                  ? "text-[#1F9358]"
                  : (
                      statusDict[props.transaction.status] ||
                      props.transaction.status
                    )
                      .toLowerCase()
                      .includes("pending")
                  ? "text-[#F57C00]"
                  : "text-[#E04D5C]"
              }`}
            >
              {statusDict[props.transaction.status]
                ? titleCase(statusDict[props.transaction.status])
                : titleCase(props.transaction.status)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  circle: {
    borderRadius: "50%",
    width: "34px",
    height: "34px",
    aspectRatio: "1/1",
  },
}));
